import { REACT_APP_API_URL } from "../configs/config";

/**
 * Get dashboard summary statistics
 * @param token - Authentication token
 * @returns Promise with the dashboard summary data
 */
const getDashboardSummary = async (token) => {
  const response = await fetch(`${REACT_APP_API_URL}admin/dashboard/summary`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  });
  
  const responseJson = await response.json();
  return responseJson;
};

/**
 * Get monthly user growth statistics for the current year and daily growth for the last 30 days
 * @param token - Authentication token
 * @returns Promise with the user growth data including monthly and daily statistics
 */
const getUserGrowthStats = async (token) => {
  const response = await fetch(`${REACT_APP_API_URL}admin/dashboard/user-growth`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
  });
  
  const responseJson = await response.json();
  return responseJson;
};

export { getDashboardSummary, getUserGrowthStats };
